import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ModalController, Platform } from "ionic-angular";
import { PlanOfCareDataService } from "../../../providers/poc-data-service/poc-data-service";

@Component({
  selector: "goal",
  templateUrl: "goal.html",
})
export class GoalComponent {
  @Input() data;
  @Input() status;
  @Input() siblingCount;
  @Input() selectedData;
  @Input() disabled: boolean = false;
  expanded: boolean = true;

  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  @Output() onUpdateItem: EventEmitter<any> = new EventEmitter();

  constructor(
    private dataService: PlanOfCareDataService,
    public modalCtrl: ModalController,
    public plt: Platform
  ) {}

  toggle() {
    this.expanded = !this.expanded;
  }

  select(data) {
    if (!data.type) {
      data.type = "goal";
      data.siblingCount = this.siblingCount;
    }

    this.onSelect.emit(data);
  }

  updateItem(event) {
    this.onUpdateItem.emit(event);
  }

  presentMeetGoalModal() {
    let meetGoalModal = this.modalCtrl.create(
      "UpdateStatusPage",
      {
        modalType: "meetGoal",
        data: this.data,
      },
      { enableBackdropDismiss: false }
    );
    meetGoalModal.onDidDismiss((data) => {
      if (data) {
        this.dataService.updateGoalStatus(this.data.uuid, data).subscribe(
          (data) => {
            this.updateItem({ data: this.data, action: "meetGoal" });
          },
          (err) => {
            // console.error(err);
          }
        );
      }
    });
    meetGoalModal.present();
  }

  presentAddInterventionModal() {
    let addInterventionModal = this.modalCtrl.create(
      "AddItemPage",
      {
        modalType: "addIntervention",
        data: this.data,
      },
      { enableBackdropDismiss: false }
    );
    addInterventionModal.onDidDismiss((data) => {
      if (data) {
        this.dataService.addIntervention(this.data.uuid, data).subscribe(
          (data) => {
            this.updateItem({
              data: this.data,
              action: "addIntervention",
              newData: data,
            });
          },
          (err) => {
            // console.error(err);
          }
        );
      }
    });
    addInterventionModal.present();
  }

  presentDiscontinueGoalModal() {
    let discontinueGoalModal = this.modalCtrl.create(
      "UpdateStatusPage",
      {
        modalType: "discontinueGoal",
        data: this.data,
      },
      { enableBackdropDismiss: false }
    );
    discontinueGoalModal.onDidDismiss((data) => {
      if (data) {
        this.dataService.updateGoalStatus(this.data.uuid, data).subscribe(
          (data) => {
            this.updateItem({ data: this.data, action: "discontinueGoal" });
          },
          (err) => {
            // console.error(err);
          }
        );
      }
    });
    discontinueGoalModal.present();
  }

  presentHistoryModal() {
    let historyModal = this.modalCtrl.create(
      "DetailsPage",
      {
        status: this.status,
        type: "goal",
        data: this.data,
      },
      { enableBackdropDismiss: false }
    );
    historyModal.onDidDismiss((data) => {});
    historyModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/components/common/goal/goal.ts